<template>
    <div>
        <template v-for="(video, index) in videos">
            <modal :key="index" :open="openVideoIndex === index" @close="doNothing">
                <template v-if="openVideoIndex === index">
                    <div class="bg-primary-500 modal-header">
                        <div class="text-center">
                            <h4 class="modal-title text-white" v-html="video.locale_content.modal_title"></h4>
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="mb-4" v-html="video.locale_content.modal_content"></div>
                        <div class="bg-black rounded">
                            <div class="mx-auto">
                                <div class="video-container" v-html="video.locale_content.source_html"></div>
                            </div>
                        </div>
                        <div class="m-t-lg">
                            <button @click="nextVideo()" class="btn btn-block btn-primary" type="button">
                                {{ video.locale_content.button_text }}
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer"></div>
                </template>
            </modal>
        </template>
    </div>
</template>

<script>
import Modal from './partials/modal.vue';

export default {
    components: {
        'modal': Modal,
    },

    props: {
        videos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            openVideoIndex: null,
            form: new Form({
                popup_video_user_id: '',
            }),
        };
    },

    mounted() {
        if (this.videos.length === 0) {
            return;
        }
        this.openVideoIndex = 0;
    },

    methods: {
        doNothing() {
            return false;
        },

        nextVideo() {
            if (typeof this.videos[this.openVideoIndex] === 'undefined') {
                return;
            }
            this.form.popup_video_user_id = this.videos[this.openVideoIndex].pivot.id;

            Globals.post('/api/v1/mark-popup-video-as-watched', this.form)
                .then(() => {
                    this.openVideoIndex++;
                    this.resetForm();
                })
                .catch(() => {
                    const errors = this.form.errors.flatten();
                    const message = errors.length > 0 ? errors[0] : this.$t('globals.unexpected_error');
                    window.toastr.clear();
                    window.toastr.error(message);
                    this.resetForm();
                });
        },

        resetForm() {
            this.form = new Form({
                popup_video_user_id: '',
            });
        },
    },
};
</script>
